import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { contentBlocks } from "./Content";
import { featureBlocks } from "./Feature";
import { galleryBlocks } from "./Gallery";
import { headingsBlocks } from "./Headings";
import { heroBlocks } from "./Hero";
import { productShotBlocks } from "./ProductShot";
import { Root } from "./Root";

export const blocks: BlockExportMapping = {
  root: Root,
  ...headingsBlocks,
  ...contentBlocks,
  ...heroBlocks,
  ...featureBlocks,
  ...galleryBlocks,
  ...productShotBlocks,
};
